import React from 'react';
import { IntlProvider } from 'react-intl';
import ContentExplorer from 'box-ui-elements/es/elements/content-explorer';

import {
  getCookie,
} from '../../utils/cookies';

export default function ContentExplorerBox() {
  const addRefreshedAccessTokenHeader = (config) => {
    config.headers['Authorization'] = 'Bearer ' + JSON.parse(getCookie('boxToken')).accessToken;
    return config;
  }

  return (
    <div className="grow margin-right-30 fill content-explorer-container">
      <IntlProvider locale="en" textComponent={React.Fragment}>
        <ContentExplorer
          rootFolderId="0"
          token={JSON.parse(getCookie('boxToken')).accessToken}
          canDownload
          logoUrl=""
          canCreateNewFolder={false}
          canShare={false}
          canRename={false}
          canDelete={true}
          contentUploaderProps={{
            isFolderUploadEnabled: true
          }}
          requestInterceptor={addRefreshedAccessTokenHeader}
        />
      </IntlProvider>
    </div>
  );
}
